import React, { Component, useRef, useState } from 'react'
import { checkTextTranslation, checkTranslation, getObject, translate } from '../../utils/useful'
import inputComponents from '../inputs/inputComponents'
import tableComponents from '../tableComponents'
import ActionButton from './ActionButton'
import StageActionButton from './StageActionButton'
import IntractionActionsList from '../IntractionActionsList'
import ActionsList from './ActionsList'
import StagesManager from '../StagesManager'
import TasksList from './TasksList'
import ActionsBtn from './ActionsBtn'
import HttpServices from '../../utils/Http.services'

class TableRow extends Component {

    state = {}

    // const indicatorMouseDown = (e) => {
    //     // pauseEvent(e)
    //     // if (e.stopPropagation) e.stopPropagation();
    //     // if (e.preventDefault) e.preventDefault();

    //     isDown = true
    //     document.addEventListener('mouseup', mouseUp)
    //     setTimeout(() => {
    //         cloneRow()
    //     }, 300);

    // }

    // const mouseUp = () => {
    //     isDown = false
    //     document.removeEventListener('mouseup', mouseUp)
    // }

    componentDidMount() {
    }

    changeValue = (key, value, extra) => {
        let myFunction = null
        this.props.headers.forEach(header => {
            if (header.key == key && header.information?.changeFunction) {
                myFunction = header.information?.changeFunction
            }
        })

        if (!myFunction && this.props.changeValue) {
            this.props.changeValue(key, value, extra)
        }

        if (myFunction && this.props.functionsHandler) {

            // console.log('myFunction', myFunction, key, value, extra)
            this.props.functionsHandler(null, myFunction, value, { ...(extra ? extra : {}), key })
        }
        // this.props.changeValue(key, value.extra)
    }

    actionClicked = (prop, extra) => {
        this.props.actionClicked(prop, this.props.data, this.props.index, extra)
        if (this.actionsButton) {
            this.actionsButton.hide()
        }
    }





    stages = (stageMap, currentStage, component) => {
        for (let i = 0; i < stageMap.length; i++) {
            const stage = stageMap[i];
            if (component) { }
            if (currentStage == stage.src) {
                let current = stage.dest
                this.stages(stageMap, current)
            }
        }
    }

    render() {
        return (
            <div ref={el => this.row = el} className="tableRow " style={{}} >
                {/* <div className='flexcc'>
                    <StageActionButton />
                </div> */}
                {(this.props.actions) && (
                    <div className='mrd-2 pld-2 flexcc' style={{}}>
                        <ActionsBtn permissions={this.props.permissions} page={this.props.page} applet={this.props.applet} data={this.props.data} index={this.props.index} actions={this.props.actions} actionClicked={this.actionClicked} language={this.props.language} currentRecord={this.props.currentRecord} currentRecordStage={this.props.currentRecordStage} changeRecordStage={this.props.changeRecordStage} setCurrentRecordStage={this.props.setCurrentRecordStage} colors={this.props.colors} functionsHandler={this.props.functionsHandler} />
                    </div>
                )}
                {/* {console.log('thisppprops',this.props)} */}
                {this.props.headers?.map((header, index) => {
                    // console.log('headerlll',header)
                    if (header.showMain != false) {
                        let padding = null
                        let isSticky = false
                        // let selectedCell = (this.props.tempValue?.id == this.props.id && this.props.tempValue?.key == header.key) ? true : false
                        // console.log(this.props.id)
                        let selectedCell = (this.props.selectedCell && this.props.selectedCell[`${this.props.id}-${header.key}`]) ? true : false
                        if (index === 0 && Math.abs(this.props.scrollX) > 5) {
                            // isSticky = true
                        }
                        let data

                        if (header.type == "StageInput") {
                            // console.log('header.key',header.key)
                            // console.log('this.props.data000',this.props.data)
                            data = getObject(this.props.data, '**stage.value.stage')
                            // data = this.props.data
                            // console.log('data is',data)
                        }
                        // else if (header.type == "LookupInput") {
                        //     data = getObject(this.props.data, 'populates.records')
                        // }

                        else {
                            // if (header.key.substring(0, 7) != 'values.') {
                            //     header.key = 'values.' + header.key
                            // }
                            // console.log('header.key09',header.key)
                            // console.log('this.props.data09',this.props.data)
                            data = getObject(this.props.data, header.key)
                        }
                        if (this.props.tempValue && this.props.tempValue[`${this.props.id}-${header.key}`]) {
                            data = this.props.tempValue[`${this.props.id}-${header.key}`]?.newData
                        }
                        let files
                        if (this.props.tempValue && this.props.tempValue[`${this.props.id}-${header.key}`] && this.props.tempValue[`${this.props.id}-${header.key}`]['**files']) {
                            files = this.props.tempValue[`${this.props.id}-${header.key}`]['**files']
                        }
                        let Component = tableComponents[header.type]
                        if (header?.information?.inplaceEditable) {
                            Component = inputComponents[header.type]
                        }
                        if (index == 0) {
                            padding = this.props.firstRowpadding ?? 0
                        } else {
                            padding = 8
                        }
                        if (this.props.maxIndex == null || index < this.props.maxIndex) {
                            return (
                                // <div className={"tableBodyItem flexc flex-row " + (header?.information?.inplaceEditable ? ' inplaceEditable ' : '') + (index == 0 ? ' firstTableBodyItem ' : '') + (isSticky ? ' stickytableBodyItem' : '')} key={header.key} style={{ zIndex: this.state.actionIsOpen ? 4 : (index == 0 ? 1 : 0), paddingLeft: padding, transition: 'all 0.3', flex: index == 0 ? '1 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[header.key], flexBasis: this.props.widths[header.key], width: this.props.widths[header.key] }}>
                                // {index <= this.state.pinedIndex && (
                                <div className={"tableBodyItem flexc flex-row " + (header?.information?.inplaceEditable ? ' inplaceEditable ' : '') + (index == 0 ? ' firstTableBodyItem ' : '') + (isSticky ? ' stickytableBodyItem' : '')} key={header.key} style={{ paddingLeft: padding, transition: 'all 0.3', flex: index == 0 ? '0 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[header.key], flexBasis: this.props.widths[header.key], width: this.props.widths[header.key], pointerEvents: this.props.pointer }}>
                                    {/* {index == 0 && (
                                        <div className='mrd-3' style={{}}>
                                            <ActionButton onOpen={() => this.setState({ actionIsOpen: true })} onClose={() => { this.setState({ actionIsOpen: false }) }}>
                                                <div className="  py-3 px-3 d-flex flex-column w-100" style={{ minWidth: 120, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}>
                                                    {this.props.actions && Object.values(this.props.actions).map((prop, index) => {
                                                        return (
                                                            <button onClick={() => this.props.actionClicked(prop, this.props.data, this.props.index)} className="w-100 p-0 text-start flexcb mt-1" >
                                                                <p className="text-small  ">{checkTranslation(prop.label)}</p>
                                                                <img src='/assets/icons/useful/text.svg' height={15} />

                                                            </button>
                                                        )
                                                    })}
                                                </div>
                                            </ActionButton>
                                        </div>
                                    )} */}
                                    <div className={'tabel-cell component-container w-100 ' + (selectedCell ? 'selected-cell' : '')} style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()} >
                                        {header.information?.inplaceEditable && !selectedCell && (
                                            <div className='overlay h-100 w-100 position-absolute top-0 left-0' onClick={() => this.props.changeSelected(this.props.id, header.key, data)} ></div>
                                        )}
                                        {Component && (
                                            <Component data={data} header={header} fullData={this.props.data} changeValue={this.changeValue} automations={this.props.automations} changeFiles={this.changeFiles} files={files} extra={{ index: this.props.index, _id: this.props.id }} tableCell={true} />
                                        )}
                                    </div>
                                </div>
                            )
                        }
                    }
                })}
                {/* {this.props.settings?.extendedActions && this.props.actions?.map((prop, index) => {
                    let isSticky = false
                    return (
                        <div className={"tableBodyItem " + (isSticky ? 'stickytableBodyItem' : '')} key={header.key} style={{ transition: 'all 0.3', flex: index == 0 ? '1 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[header.key], flexBasis: this.props.widths[prop.key] }}>
                            <p >{checkTranslation(this.props.data[prop.key])}</p>
                        </div>
                    )
                })} */}
                {/* {
                    !this.props.settings?.extendedActions && this.props.actions && (
                        <div className={"tableBodyItem px-3 py-1"} style={{ transition: 'all 0.3', flex: '0 0', maxWidth: this.props.widths['*actions'], flexBasis: this.props.widths['*actions'] }}>
                            <button onClick={() => this.props.openActionsModal(this.props.data, this.props.index)} style={{ background: '#677dc415', borderRadius: 20, padding: '4px 12px' }}>
                                <p className="text-smaller text-bold text-uppercase" style={{ color: '#677dc4aa' }}>{checkTranslation('{{lang}}actions')}</p>
                            </button>
                        </div>
                    )
                } */}
            </div >
        )
    }
}

export default TableRow
